module.exports = __webpack_public_path__ + "res/Roboto-Medium-webfont.svg?2aedf1fb6a77740ad5833649ca7a3fdb";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Medium-webfont.svg
// module id = 80
// module chunks = 0